module.exports = __webpack_public_path__ + "cement/img/1(2).dfdd12b9.png";